import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Dialog from 'material-ui/Dialog';
import RaisedButton from 'material-ui/RaisedButton';
import LinearProgress from 'material-ui/LinearProgress';
import { CardTitle } from 'material-ui/Card';
import CardHead from '../../CardHead';
import { httpStatus } from './../../../data/constants/';
import * as linearCalendarActions from '../../../data/linearCalendar/actions';
import { useLanguage } from './../../../context/LanguageContext';
import './styles.scss';

class LegalityCheck extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: true,
      isFetching: true,
      legality: {
        message: '',
        subMessage: '',
        cssIconClass: '',
        reports: []
      }
    };
  }

  componentDidMount() {
    const {
      bidSessionId,
      categoryId,
      staffId,
      activitiesIds,
      showNotification,
      legalityCheckLabels,
      openTimeSearchLabels
    } = this.props;

    linearCalendarActions.default
      .checkLegalityService(bidSessionId, categoryId, staffId, activitiesIds)()
      .then(response => {
        if (response && response.status === httpStatus.OK) {
          switch (response.data.legality) {
            case legalityCheckLabels?.RESPONSES?.LEGAL:
              this.setModalData(
                legalityCheckLabels?.MESSAGES?.LEGAL?.TITLE,
                legalityCheckLabels?.MESSAGES?.LEGAL?.SUBTITLE,
                'legality-subheader-legal'
              );
              break;
            case legalityCheckLabels?.RESPONSES?.NOT_LEGAL:
              this.setModalData(
                legalityCheckLabels?.MESSAGES?.NOT_LEGAL?.TITLE,
                legalityCheckLabels?.MESSAGES?.NOT_LEGAL?.SUBTITLE,
                'legality-subheader-not-legal',
                response.data.reports
              );
              break;
            default:
              this.setModalData(
                openTimeSearchLabels?.ANALYZER?.MESSAGES?.PREFIX,
                response.data.message,
                'legality-subheader-warning'
              );
              break;
          }
        }
      })
      .catch(e => {
        const errorMessage = e.response.data.hasOwnProperty.call(
          e.response.data,
          'fails'
        )
          ? legalityCheckLabels?.RESPONSES?.CATCH
          : e.response.data.message;
        this.setModalData(
          openTimeSearchLabels?.ANALYZER?.MESSAGES?.PREFIX,
          errorMessage,
          'legality-subheader-warning'
        );
        this.props.handleClose();
      });
  }

  setModalData = (message, subMessage, cssIconClass, reports = []) => {
    this.setState(state => ({
      ...state,
      isFetching: false,
      legality: {
        ...state.legality,
        message,
        subMessage,
        cssIconClass,
        reports: reports.length > 0 ? reports : []
      }
    }));
  };

  handleClose = () => {
    this.props.handleClose();
    this.setState(state => ({ ...state, open: false }));
  };

  render() {
    const { legalityCheckLabels } = this.props;
    const actions = [
      <RaisedButton
        className='next-button legal-cancel-btn'
        label='Close'
        primary
        onClick={this.handleClose}
      />
    ];
    const loader = (
      <div className='loader-wrapper'>
        <span>{legalityCheckLabels?.LOADER}</span>
        <LinearProgress mode='indeterminate' className='progress-bar' />
      </div>
    );
    const legalityMessage = (
      <div>
        <CardHead
          headClassName={this.state.legality.cssIconClass}
          title={this.state.legality.message}
          subtitle={this.state.legality.subMessage}
        />
        {this.state.legality.reports.length > 0 && (
          <div className='report-wrapper'>
            <h4>{legalityCheckLabels?.REPORTS}</h4>
            <ul>
              {this.state.legality.reports.map(report => (
                <li key={report}>{report}</li>
              ))}
            </ul>
          </div>
        )}
      </div>
    );

    return (
      <Dialog
        key={1}
        actions={actions}
        open={this.state.open}
        onRequestClose={this.handleClose}
        title={
          <div className='no-margin'>
            <CardTitle
              title={legalityCheckLabels?.TITLE}
              subtitle={legalityCheckLabels?.SUBTITLE}
              className='bid-adding-title'
            />
          </div>
        }
        contentStyle={{ width: '85%', maxWidth: '950px' }}
        style={{ zIndex: 2103 }}
        actionsContainerClassName='action-container'
      >
        {this.state.isFetching && loader}
        {!this.state.isFetching && legalityMessage}
      </Dialog>
    );
  }
}

LegalityCheck.propTypes = {
  activitiesIds: PropTypes.array.isRequired,
  bidSessionId: PropTypes.number.isRequired,
  categoryId: PropTypes.number.isRequired,
  handleClose: PropTypes.func.isRequired,
  showNotification: PropTypes.func.isRequired,
  staffId: PropTypes.string.isRequired,
  legalityCheckLabels: PropTypes.object,
  openTimeSearchLabels: PropTypes.object
};

LegalityCheck.defaultProps = {
  legalityCheckLabels: {},
  openTimeSearchLabels: {}
};

function LegalityCheckWrapper(props) {
  const { labels } = useLanguage();
  return (
    <LegalityCheck
      {...props}
      legalityCheckLabels={labels.legalityCheck}
      openTimeSearchLabels={labels.openTimeSearchLabels}
    />
  );
}

export default LegalityCheckWrapper;
